export default __webpack_public_path__ + "static/media/TXNE40-min.f322f307.jpeg";